module.exports = __webpack_public_path__ + "img/map_full.93c808d9.jpg";